

// событие успешной отправки формы
App.gtmFormSubmit = function (formEl) {
    window.dataLayer = window.dataLayer || [];
    let data = {
        "event": "form_submit",
        "DOMelement": formEl
    };
    window.dataLayer.push(data);

    // data = JSON.parse(JSON.stringify(data));
    // window.parent.postMessage(data, "*");

    try {
        var postObject = JSON.stringify({
            event: "form_submit",
            DOMelement: formEl // элемент формы
        });
        window.parent.postMessage(postObject, "*");
    } catch(e) {
        window.console && window.console.log(e);
    }
};
